import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useForm } from '@mantine/form'
import { userAdditionalInfoValidation } from './validation'

export const useUserAdditionalInfoForm = () => {
  return useForm({
    mode: 'controlled',
    validate: zod4Resolver(userAdditionalInfoValidation()),
    initialValues: {
      country_id: null,
      province_id: null,
      city_id: null,
      address_line: '',
      subdistrict: '',
      zip_code: '',
      withdraw_provider: '',
      withdraw_account_name: '',
      withdraw_account_number: '',
      withdraw_swift_code: '',
    },
    transformValues: (values) => {
      return {
        addresses: [
          {
            country_id: Number(values.country_id),
            province_id: values.province_id ? Number(values.province_id) : null,
            city_id: values.city_id ? Number(values.city_id) : null,
            address_line: values.address_line || null,
            subdistrict: values.subdistrict || null,
            zip_code: values.zip_code || null,
          }
        ],
        extras: {
          withdraw_method: 'bank_transfer',
          withdraw_provider: values.withdraw_provider || null,
          withdraw_account_name: values.withdraw_account_name || null,
          withdraw_account_number: values.withdraw_account_number || null,
          withdraw_swift_code: values.withdraw_swift_code || null,
        }
      }
    }
  })
}